import React, { useEffect, useState } from "react";
import ProjectGallery from "../projects/ProjectGallery";

const Galleries = ({ data = [], tabIndex }) => {
  if (!data.length) return null;
  return <GalleryTabs data={data} tabIndex={tabIndex} />;
};

const GalleryTabs = ({ data, tabIndex }) => {
  const [projectTab, setProjectTab] = useState(0);
  const [yearTab, setYearTab] = useState("");

  useEffect(() => {
    setProjectTab(0);
    setYearTab("");
  }, [tabIndex]);

  const gallery = data[projectTab]?.gallery || [];

  // 🔹 Extract unique years
  const years = Array.from(
    new Set(
      gallery
        .map(item => item.title?.match(/\d{4}/)?.[0])
        .filter(Boolean)
    )
  ).sort((a, b) => b - a);

  // 🔹 Auto select latest year
  useEffect(() => {
    if (years.length && !yearTab) {
      setYearTab(years[0]);
    }
  }, [years, yearTab]);

  // 🔹 Filter months by selected year
  const filteredGallery = gallery.filter(item =>
    item.title?.includes(yearTab)
  );

  return (
    <>
      {/* PROJECT NAME TABS */}
      <div className="gallery-tabs project-tabs">
        {data.map((item, idx) => (
          <button
            key={idx}
            onClick={() => {
              setProjectTab(idx);
              setYearTab("");
            }}
            className={`btn${projectTab === idx ? " active" : ""}`}
          >
            {item.title}
          </button>
        ))}
      </div>

      {/* YEAR ROW (SINGLE ROW) */}
      {years.length > 0 && (
        <div className="gallery-tabs year-tabs">
          {years.map(year => (
            <button
              key={year}
              onClick={() => setYearTab(year)}
              className={`btn${yearTab === year ? " active" : ""}`}
            >
              {year}
            </button>
          ))}
        </div>
      )}

      {/* MONTHS + IMAGES */}
      {filteredGallery.length > 0 && (
        <ProjectGallery gallery={filteredGallery} />
      )}
    </>
  );
};

export default Galleries;
